module.exports = __webpack_public_path__ + "img/Characters-Cho-Sang-Woo-Seong-Gi-Hun-and-Abdul-Ali-in-Squid-Game.1db9c149.jpg";